import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { YourjssiteamComponent } from '../yourjssiteam/yourjssiteam.component';
import { Question } from '../../models/Question';
import { QuestionService } from '../../services/question.service';
import { QuestionFile } from '../../models/QuestionFile';
import { NgxSpinnerService } from 'ngx-spinner';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageSuccessComponent } from '../confirmation-page-success/confirmation-page-success.component';
// tslint:disable-next-line:max-line-length
import { ConfirmationPageFailComponent } from '../confirmation-page-fail/confirmation-page-fail.component';


@Component({
  selector: 'app-ask-question-form',
  templateUrl: './ask-question-form.component.html',
  styleUrls: ['./ask-question-form.component.scss']
})
export class AskQuestionFormComponent implements OnInit, OnDestroy {

  @Input('username') username: string;
  @Input('email') email: string;
  @Input('contractNum') contractNum: string;
  @Output('submitClick') submitClick: EventEmitter<any> = new EventEmitter();
  @Output('cancelClick') cancelClick: EventEmitter<any> = new EventEmitter();
  @ViewChild('FileInput') inputVariable: any;

  public yourJssiTeam: any;
  fileToUpload: File = null;
  textAreaModel: string;
  currTime: Date;
  reader: FileReader = new FileReader();
  showInvalidFileMessage = false;
  InvalidFileMessage: string;
  public fileData: Uint8Array;
  category = [
    { id: 0, name: 'My Contract' },
    { id: 1, name: 'My Invoice' },
    { id: 2, name: 'My Payment' },
    { id: 3, name: 'My Maintenance' },
    { id: 4, name: 'My Coverage' },
    { id: 5, name: 'Request Quote' }
  ];
  selectedCategoryId: any;
  selectedCategoryIds: any[];

  private alive = true;

  question: Question = new Question();
  questionFile: QuestionFile = new QuestionFile();

  constructor(private questionService: QuestionService,
              private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.yourJssiTeam = [1, 2, 3];
  }

  onSubmitClick() {
   // this.question = new Question();
    this.currTime = new Date();
    this.question.Email = this.email;
    this.question.Name = this.username;
    this.question.ContractNumber = this.contractNum;
    this.question.CategoryID = this.selectedCategoryId;
    this.question.Category = this.category[this.selectedCategoryId].name;
    this.question.QDesc = this.textAreaModel;
    this.question.QDate = Date.now().toString();
    this.questionService.pushQuestion(this.question);
    this.submitClick.emit(null);
  }

  onCancelClick() {
    this.cancelClick.emit(null);
  }

  getRemaining(textAreaModel: string, maximum: number): string {
    return `${textAreaModel ? maximum - textAreaModel.length : maximum} characters remaining`;
  }

  wait2sec() {
    return new Promise(function(resolve, reject) {
      setTimeout(function() {
        resolve();
      }, 2000);
    });
  }

  resetFileInput() {
    this.inputVariable.nativeElement.value = "";
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
     this.fileData = new Uint8Array(this.reader.result);
    };
    /*this.reader.onprogress = function(data) {
      if (data.lengthComputable) {
        let progress = parseInt( ((data.loaded / data.total) * 100), 10 );
        console.log()
      }
    }*/
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
}

  async handleFileInput(files: FileList) {
    this.showInvalidFileMessage = false;
    if (files.length !== 1) {
      console.log('Only support upload 1 file');
      this.resetFileInput();
      return;
    }
   // console.log(files[0]);
    // File size limit, 5M
    if (files[0].size > 5242880) {
      this.InvalidFileMessage = "This file's size exceeds the limit";
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();

    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.InvalidFileMessage = "We don't support " + fileExt + " file";
      this.showInvalidFileMessage = true;
      this.resetFileInput();
      return;
    }
    this.spinner.show();
    this.readFile(files);
    await this.wait2sec();
    this.questionFile.fileName = this.contractNum + Date.now().toString() + fileExt;
    this.question.AttachmentFilePath = this.questionFile.fileName;
    this.question.FileName = files[0].name;
    // this.questionFile.fileData = btoa(this.fileData.reduce((data, byte) => data  + String.fromCharCode(byte), ''));
    this.questionFile.fileData = this.arrayBufferToBase64(this.fileData);
    this.questionService.submitFile(this.questionFile)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.spinner.hide();
        console.log(data);
      },
      err => {
        this.spinner.hide();
        this.question.AttachmentFilePath = null;
        this.question.FileName = null;
        console.log(err);
      }
    );
  }

  public ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/ask-question-form/ask-question-form.component.ts